// ペイウォール。無料の3本枠を超えたときに出す購入シート。月/年/ライフタイムの3択を「選べるカード」で見せ、
// ライフタイム（買い切り）を“おすすめ”として強調。実決済はまだ無い＝「購入（ダミー）」でフラグを立てて全解放
//（ネイティブ段階で StoreKit/Web/RevenueCat に差し替え）。文言はすべて i18n（t()）経由。
import { setPurchased, FREE_LIMIT } from './entitlements.js'
import { icon } from './icons.js'
import { t } from './i18n.js'

// 表示順と各カードの i18n キー。recommended＝おすすめバッジ＋既定選択。
const PLANS = [
  { id: 'month', name: 'paywall.plan.month', price: 'paywall.price.month', note: '' },
  { id: 'year', name: 'paywall.plan.year', price: 'paywall.price.year', note: 'paywall.note.year', recommended: true },
  { id: 'lifetime', name: 'paywall.plan.lifetime', price: 'paywall.price.lifetime', note: 'paywall.note.lifetime' },
]
const DEFAULT_PLAN = 'year'

let overlayEl = null
function close() {
  if (overlayEl) {
    overlayEl.remove()
    overlayEl = null
  }
}

function planCardHtml(p, selected) {
  const badge = p.recommended ? `<span class="pw-badge">${t('paywall.recommended')}</span>` : ''
  const note = p.note ? `<span class="pw-plan-note">${t(p.note)}</span>` : ''
  return `<button class="pw-plan${selected ? ' sel' : ''}${p.recommended ? ' rec' : ''}" data-id="${p.id}">
      ${badge}
      <span class="pw-plan-name">${t(p.name)}</span>
      <span class="pw-plan-price">${t(p.price)}</span>
      ${note}
    </button>`
}

export function showPaywall() {
  close()
  let selected = DEFAULT_PLAN
  overlayEl = document.createElement('div')
  overlayEl.className = 'paywall-overlay'
  overlayEl.innerHTML = `
    <div class="paywall paywall-buy">
      <div class="paywall-lock">${icon('lock')}</div>
      <div class="paywall-title">${t('paywall.title')}</div>
      <p class="paywall-desc">${t('paywall.desc', { n: FREE_LIMIT })}</p>
      <ul class="paywall-feats">
        <li>${icon('check')}<span>${t('paywall.feat.all')}</span></li>
        <li>${icon('check')}<span>${t('paywall.feat.unlimited')}</span></li>
        <li>${icon('check')}<span>${t('paywall.feat.lifetime')}</span></li>
      </ul>
      <div class="paywall-plan-list">
        ${PLANS.map((p) => planCardHtml(p, p.id === selected)).join('')}
      </div>
      <button class="btn" id="pw-buy">${t('paywall.buyDummy')}</button>
      <button class="btn ghost" id="pw-restore">${t('paywall.restore')}</button>
      <button class="btn secondary" id="pw-close">${t('common.close')}</button>
      <div class="paywall-note">${t('paywall.note')}</div>
    </div>`
  const list = overlayEl.querySelector('.paywall-plan-list')
  const selectCard = (id) => {
    selected = id
    list.querySelectorAll('.pw-plan').forEach((el) => el.classList.toggle('sel', el.dataset.id === id))
  }
  overlayEl.addEventListener('click', (e) => {
    const card = e.target.closest('.pw-plan')
    if (card) { selectCard(card.dataset.id); return }
    if (e.target.closest('#pw-buy')) {
      // プロトタイプ＝ダミー購入。選択プランに関わらずフラグを立てて全解放（実決済はネイティブ段階）。
      setPurchased(true)
      close()
      location.reload()
      return
    }
    if (e.target.closest('#pw-restore')) {
      const b = overlayEl.querySelector('#pw-restore')
      b.textContent = t('paywall.restoreNone')
      b.disabled = true
      return
    }
    if (e.target === overlayEl || e.target.closest('#pw-close')) close()
  })
  document.body.appendChild(overlayEl)
}
